import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";
import AdminPageShell from "@/admin/AdminPageShell";
import { CheckCircle2, Circle } from "lucide-react";

const TRACKERS = [
  { key: "ga4_measurement_id", label: "Google Analytics 4" },
  { key: "gtm_container_id", label: "Google Tag Manager" },
  { key: "meta_pixel_id", label: "Meta Pixel" },
  { key: "linkedin_insight_tag_id", label: "LinkedIn Insight Tag" },
  { key: "microsoft_clarity_id", label: "Microsoft Clarity" },
];

// Live analytics dashboards require the respective provider's reporting
// API (out of scope for now). This module shows configuration status so
// the team knows exactly what remains to be connected before launch.
const AdminAnalytics = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => { adminApi.get("/settings").then((res) => setSettings(res.data)).finally(() => setLoading(false)); }, []);

  return (
    <AdminPageShell title="Analytics" description="Configuration status for tracking/analytics providers. Live reporting dashboards will appear here once each provider is connected in Settings." testId="admin-analytics-page">
      {loading ? <p className="text-small">Loading…</p> : (
        <div className="grid sm:grid-cols-2 gap-5">
          {TRACKERS.map((t) => {
            const configured = !!settings[t.key];
            return (
              <div key={t.key} className="neu-surface p-6 flex items-center gap-4" data-testid={`admin-analytics-${t.key}`}>
                {configured ? <CheckCircle2 size={20} style={{ color: "var(--gg-logo-gold)" }} /> : <Circle size={20} style={{ color: "var(--gg-muted-text)" }} />}
                <div>
                  <p className="text-body font-semibold" style={{ color: "var(--gg-ivory)" }}>{t.label}</p>
                  <p className="text-small">{configured ? "Configured" : "Not yet configured"}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </AdminPageShell>
  );
};

export default AdminAnalytics;
